import { Scene } from 'phaser'
import levelJson from '@/game/jump/assets/json/levelData.json'
import { store } from '@/store/store'

function setLoadingFalse() {
  store.dispatch('updateLoader', false)
}

export default class PlayScene extends Scene {
  constructor () {
    super({ key: 'PlayScene' })
  }

  init () {
    this.StageHeight = this.sys.game.config.height
    this.StageWidth = this.sys.game.config.width
  
    this.gameDetails = {
      blockSize: 10000,
      TopGap: 100,
      BottomGap: 100,
      LeftGap: 30,
      RightGap: 30,
    }

    this.oldLevelData = null
    this.gameTimer = 0
    this.runTimer = true
    this.attemptCount = 0
  }

  preload () {
    this.GridArray = []
    this.PadsArray = []

    this.currentLevel = 1

    this.buttonPressed = false

    this.load.json('levelData', levelJson)
  }

  create () {
    setLoadingFalse()

    this.levelData = this.cache.json.get('levelData')
    this.cursors = this.input.keyboard.createCursorKeys()
    this.pressed = false
    
    this.pointerEvents()
    this.createGridArray()
    this.placePlayer()
    this.startTimer()

    
  }
  
  CountAttempt () {
    this.attemptCount++
  }
  
  startTimer () {
    var gameClock = setInterval(() => {
      this.gameTimer++
      if (!this.runTimer) {
        clearInterval(gameClock)
      }
    }, 1000)
  }

  createGridArray () {
    this.GridArray = []
    var singleLevelDetails = this.levelData.levels[this.currentLevel - 1]
  
    this.totalRows = singleLevelDetails.rows
    this.totalCols = singleLevelDetails.cols
    
    for (let i = 0; i < this.totalRows; i++) {
  
      var activeYSpots = singleLevelDetails.platforms.filter(function (yLocation) {
        return yLocation.y == i + 1;
      })
  
      for (let k = 0; k < this.totalCols; k++) {
        var gridPoint = { 
          y: i + 1, 
          x: k + 1,
          id: (i + 1) + '_' + (k + 1),
          gotPoint: false
        }
        for (let m = 0; m < activeYSpots.length; m++) {
          if (activeYSpots[m].x == k + 1) {
            gridPoint.gotPoint = true
            if (activeYSpots[m].start) {
              gridPoint.start = true
            }
          }
        }
  
        this.GridArray.push(gridPoint)
      }
    }
  
    this.createGrid()
  }

  createGrid () {
    this.PadsArray = []
    this.blockSize = this.gameDetails.blockSize
    var largestSizeX = (this.StageWidth - (this.gameDetails.LeftGap + this.gameDetails.RightGap)) / this.totalCols
    var largestSizeY = (this.StageHeight - (this.gameDetails.TopGap + this.gameDetails.BottomGap)) / this.totalRows
  
    if (this.blockSize > largestSizeX) {
      this.blockSize = largestSizeX
    }
    if (this.blockSize > largestSizeY) {
      this.blockSize = largestSizeY
    }  
    
    let blockCounter = 0

    for (let i = 0; i < this.GridArray.length; i++) {
      if (this.GridArray[i].gotPoint) {
        let imageName = null
        if (this.GridArray[i].start) {
          imageName = 'start'
        } else {
          blockCounter++

          if (blockCounter == 4) {
            blockCounter = 1
          }

          imageName = 'pad_' + blockCounter
        }
        let xLocation = this.gameDetails.LeftGap + (this.blockSize * (this.GridArray[i].x - 1))
        let yLocation = this.gameDetails.TopGap + (this.blockSize * (this.GridArray[i].y - 1))
        let block = this.add.sprite(xLocation, yLocation, imageName).setOrigin(0)
        block.displayWidth = this.blockSize
        block.displayHeight = this.blockSize
        block.id = this.GridArray[i].y + '_' + this.GridArray[i].x
  
        this.PadsArray.push(block)
      }
    }
  }

  placePlayer (redoLevel) {
    let copyOfData = JSON.stringify(this.levelData.levels[this.currentLevel - 1].player)

    this.playerLevelData = JSON.parse(copyOfData)
    
    if (redoLevel) {
      this.playerLevelData = JSON.parse(this.oldLevelData)
    } else {
      this.oldLevelData = JSON.stringify(this.playerLevelData)
    }
  
    let playerX = this.gameDetails.LeftGap + (this.blockSize * (this.playerLevelData.x - 1))
    let playerY = this.gameDetails.TopGap + (this.blockSize * (this.playerLevelData.y - 1))
  
    this.playerObject = this.add.sprite(playerX, playerY, 'player', 0).setOrigin(0)
    this.playerObject.displayWidth = this.blockSize
    this.playerObject.displayHeight = this.blockSize
    this.playerObject.direction = this.playerLevelData.direction

    if (this.playerObject.direction == 'left') {
      this.playerObject.setFrame(1)

    } else if (this.playerObject.direction == 'right') {
        this.playerObject.setFrame(3)

    } else if (this.playerObject.direction == 'up') {
        this.playerObject.setFrame(2)

    } else if (this.playerObject.direction == 'down') {
        this.playerObject.setFrame(0)
    }
  }

  pointerEvents () {
    var downX, upX, downY, upY, threshold = 50
    var pointer = this.scene.scene.input
  
    pointer.on('pointerdown', function (pointer) {
      downX = pointer.x
      downY = pointer.y
    })
    pointer.on('pointerup', function (pointer) {
      upX = pointer.x
      upY = pointer.y
      if (upX < downX - threshold){
        this.movePlayer('left')
      } else if (upX > downX + threshold) {
        this.movePlayer('right')
      } else if (upY < downY - threshold) {
        this.movePlayer('up')
      } else if (upY > downY + threshold) {
        this.movePlayer('down')
      }
    }, this)
  }

  movePlayer (direction) {
    let nearest = null
    if (direction == 'up' || direction == 'down') {
      var yMove = this.GridArray.filter(function (yLocation) {
        return yLocation.x == this.playerLevelData.x && yLocation.gotPoint == true
      }, this)
    }
    if (direction == 'left' || direction == 'right') {
      var xMove = this.GridArray.filter(function (xLocation) {
        return xLocation.y == this.playerLevelData.y && xLocation.gotPoint == true
      }, this)
    }
  
    if (direction == 'left' && this.playerLevelData.direction !== direction) {
      nearest = this.findClosestArray(this.playerLevelData.x, xMove, 'x', 'neg')
      if (nearest && this.playerLevelData.x !== 1) {
        this.removePointFromArray(this.playerLevelData)
  
        let difference = this.playerLevelData.x - nearest.x
        this.playerLevelData.x -= difference
        this.playerLevelData.direction = 'right'
        this.playerObject.setFrame(3)
        this.movePlayerMovement('-x', this.blockSize * difference)
  
      } else {
        this.noMoves()
        return
      }
  
  
    } else if (direction == 'right' && this.playerLevelData.direction !== direction) {
      nearest = this.findClosestArray(this.playerLevelData.x, xMove, 'x', 'pos')
      if (nearest && this.playerLevelData.x !== this.totalCols) {
        this.removePointFromArray(this.playerLevelData)
  
        let difference = nearest.x - this.playerLevelData.x
        this.playerLevelData.x += difference
        this.playerLevelData.direction = 'left'
        this.playerObject.setFrame(1)
        this.movePlayerMovement('x', this.blockSize * difference)
      } else {
        this.noMoves()
        return
      }
  
  
    } else if (direction == 'up') {
      nearest = this.findClosestArray(this.playerLevelData.y, yMove, 'y', 'neg')
      if (nearest && this.playerLevelData.y > 1) {
        this.removePointFromArray(this.playerLevelData)
  
        let difference = this.playerLevelData.y - nearest.y
        this.playerLevelData.y -= difference
        this.playerLevelData.direction = 'down'
        this.playerObject.setFrame(0)
        this.movePlayerMovement('-y', this.blockSize * difference)
      } else {
        this.noMoves()
        return
      }
  
    } else if (direction == 'down' && this.playerLevelData.direction !== direction) {
      nearest = this.findClosestArray(this.playerLevelData.y, yMove, 'y', 'pos')
      if (nearest && this.playerLevelData.y !== this.totalRows) {
        this.removePointFromArray(this.playerLevelData)
  
        let difference = nearest.y - this.playerLevelData.y
        this.playerLevelData.y += difference
        this.playerLevelData.direction = 'up'
        this.playerObject.setFrame(2)
        this.movePlayerMovement('y', this.blockSize * difference)
      } else {
        this.noMoves()
        return
      }
      
    } else {
      this.noMoves()
    }
  }

  findClosestArray (current, arr, XY, direction) {
    let currentIndex = arr.findIndex(x => x[XY] === current)
    let resultArray = arr.slice()
    resultArray.splice(currentIndex, 1)
    if (resultArray.length == 0) {
      return false
    }
  
    var nearestNumber = resultArray[0]
    resultArray.forEach(element => {
      if (element[XY] == current) {
      } else if (direction == 'pos') {
        if (Math.abs(element[XY] - current) < Math.abs(element[XY] - nearestNumber[XY])) {
          nearestNumber = element
        }
      } else if (direction == 'neg') {
        if (Math.abs(element[XY] - current) > Math.abs(element[XY] - nearestNumber[XY])) {
          nearestNumber = element
        }
      }
    })
  
    if ((direction == 'pos' && current > nearestNumber[XY]) || (direction == 'neg' && current < nearestNumber[XY])) {
      return false
    } else {
      return nearestNumber
    }
  }

  removePointFromArray (current) {
    let currentPointIndex = this.PadsArray.findIndex(singlePoint => singlePoint.id === current.y + '_' + current.x)
    let currentGridIndex = this.GridArray.findIndex(singlePoint => singlePoint.id === current.y + '_' + current.x)
    
    this.GridArray[currentGridIndex] = false
  
    this.PadsArray[currentPointIndex].destroy()
    this.PadsArray.splice(currentPointIndex, 1)
  }

  noMoves () {
    this.cameras.main.shake(500, 0.01)
    // this.wrongSound.play()
  }

  buildLevel () {
    this.clearBoard()
    setTimeout(() => {
      this.createGridArray()
      this.placePlayer()
    }, 150)
  }

  restartLevel () {
    this.clearBoard()
    setTimeout(() => {
      this.CountAttempt()
      this.createGridArray()
      this.placePlayer(true)
    }, 150)
  }

  clearBoard () {
    this.PadsArray.forEach(element => {
      element.destroy()
    })
  
    this.playerObject.destroy()
  }

  movePlayerMovement (moveDirection, moveAmount) {
    let stepSize = 10
    let repeatV = Math.floor(moveAmount / stepSize)
    if (moveDirection == 'x') {
      this.playerObject.x += (moveAmount - (repeatV * stepSize))
    } else if (moveDirection == 'y') {
      this.playerObject.y += (moveAmount - (repeatV * stepSize))
    } else if (moveDirection == '-x') {
      this.playerObject.x -= (moveAmount - (repeatV * stepSize))
    } else if (moveDirection == '-y') {
      this.playerObject.y -= (moveAmount - (repeatV * stepSize))
    }
    let index = 0
    this.time.addEvent({
      delay: 10,
      repeat: repeatV - 1,
      callbackScope: this,
      callback: function () {
        if (moveDirection == 'x') {
          this.playerObject.x += stepSize
        } else if (moveDirection == 'y') {
          this.playerObject.y += stepSize
        } else if (moveDirection == '-x') {
          this.playerObject.x -= stepSize
        } else if (moveDirection == '-y') {
          this.playerObject.y -= stepSize
        }
        index++
        if (index === repeatV) {
          if (this.PadsArray.length == 1) {
            if (this.currentLevel == this.levelData.levels.length) {
              this.endGame()
            } else {
              this.currentLevel++
              this.buildLevel()
            }
          }
        }
      }
    })
  }

  destroyGame () {
    this.sys.game.destroy(true);
  }

  endGame () {
    this.runTimer = false
    
    this.time.addEvent({
      delay: 250,
      callbackScope: this,
      callback: function () {
        this.scene.start('EndScene', { time: this.gameTimer, moves: this.attemptCount })
      }
    })
  }

  update () {
    if (this.cursors.left.isDown) {
      if (!this.pressed) {
        this.pressed = true
        this.movePlayer('left')
      }
    } else if (this.cursors.right.isDown) {
      if (!this.pressed) {
        this.pressed = true
        this.movePlayer('right')
      }
  
    } else if (this.cursors.up.isDown)  {
      if (!this.pressed) {
        this.pressed = true
        this.movePlayer('up')
      }
  
    } else if (this.cursors.down.isDown)  {
      if (!this.pressed) {
        this.pressed = true
        this.movePlayer('down')
      }
  
    }
  
    if (this.cursors.space.isUp && this.cursors.left.isUp && this.cursors.right.isUp && this.cursors.up.isUp && this.cursors.down.isUp && this.pressed) {
      this.pressed = false
    }
  }
}
